module.exports = __webpack_public_path__ + "static/media/tiktok-mobile-1.2dfd66ac.svg";